import React from 'react'

import { ErrorMessage, Field, FieldHookConfig, useField } from 'formik'

export type InputFieldProps = {
  label?: string
  parentClassName?: string
  extendOnChange?: (() => Promise<void>) & (() => Promise<any>)
  textSize?: string
} & FieldHookConfig<string>

/**
 * @deprecated use Formik > Field and customize at the feature level
 * @see useForm() hook
 */
const CheckboxField = ({
  label,
  parentClassName,
  extendOnChange,
  textSize,
  ...fieldHookConfig
}: InputFieldProps) => {
  const [field] = useField(fieldHookConfig)
  const handleChange = (e) => {
    field.onChange(e)
    extendOnChange && extendOnChange()
  }

  return (
    <div className={parentClassName}>
      {!!label && (
        <label
          htmlFor={field.name}
          className={`text-${textSize ? textSize : `sm`} text-gray-400 block mb-2`}
        >
          {label}
        </label>
      )}
      <Field
        {...fieldHookConfig}
        className='checkbox border rounded p-2 disabled:bg-gray-200 border-indigo-100 cursor-pointer'
        type='checkbox'
        onChange={handleChange}
      />
      <ErrorMessage
        component='span'
        name={fieldHookConfig.name}
        className='text-error'
      />
    </div>
  )
}

export default CheckboxField
